import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs/Observable';
import { ConfirmDialogComponent } from '../confirm-dialog';
import { LoadingphaseService } from '../../../../nav/service/loadingphase.service';
import { appConfig } from '../../../../config/app-config';
import { of } from 'rxjs/observable/of';

@Injectable()
export class ConfirmDialogsService {

   constructor(
      private dialog: MatDialog,
      private loadingphaseService: LoadingphaseService,
   ) { }

   public open(
      title: string,
      message: string,
      showCancelButton: boolean = true,
      cancelButtonText: string = 'ABBRECHEN',
      okButtonText: string = 'SPEICHERN'
   ): Observable<boolean> {

      let dialogRef: MatDialogRef<ConfirmDialogComponent>;

      const previousBlockEnabled = this.loadingphaseService.ContentBlockEnabled;
      this.loadingphaseService.enableContentBlock(false);

      dialogRef = this.dialog.open(ConfirmDialogComponent);
      dialogRef.componentInstance.title = title;
      dialogRef.componentInstance.message = message.split('<br />');
      dialogRef.componentInstance.showCancelButton = showCancelButton;
      dialogRef.componentInstance.cancelButtonText = cancelButtonText;
      dialogRef.componentInstance.okButtonText = okButtonText;

      this.loadingphaseService.enableContentBlock(previousBlockEnabled);
      return dialogRef.afterClosed();
   }

   public openHelpMessage(
      title: string,
      message: string,
      show: boolean,
   ): Observable<boolean> {
      if (!show) {
         return of(true);
      }
      return this.open(
         title, message, true, 'Nein', 'Ja',
      )
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/confirm-dialog/service/confirm-dialog.service.ts